import { Component, input } from '@angular/core';


@Component({
    selector: 'ui-icon',
    template: `
        <svg [attr.width]="width()" [attr.height]="height()" class="align-middle">
            <use [attr.href]="href()"></use>
        </svg>
    `,
})
export class IconComponent {

    href = input.required<string>();

    width = input(16);

    height = input(16);
}
